import {CALL_API} from '../../middleware/api'

export const CAPTCHA_VALIDATE_REQUEST = 'CAPTCHA_VALIDATE_REQUEST'
export const CAPTCHA_VALIDATE_SUCCESS = 'CAPTCHA_VALIDATE_SUCCESS'
export const CAPTCHA_VALIDATE_FAILURE = 'CAPTCHA_VALIDATE_FAILURE'

export function validateCaptcha(code) {
	return {
		[CALL_API]: {
			types: [CAPTCHA_VALIDATE_REQUEST, CAPTCHA_VALIDATE_SUCCESS, CAPTCHA_VALIDATE_FAILURE],
			endpoint: '/captcha/validate',
      methods: 'POST',
      params: {code}
		}
	}
}

export default (code) => {
	return (dispatch) => {
		return dispatch(validateCaptcha(code))
	}
}


// WEBPACK FOOTER //
// ./src/action/login/captchaValidate.js